module.exports = __webpack_public_path__ + "static/media/icon-fleet.e1864c8a.svg";